export const CONFIG = {
  URL: import.meta.env.VITE_URL,
  ENV: import.meta.env.VITE_ENV,
  ADMIN_URL: import.meta.env.VITE_ADMIN_URL,
  EQ_API_URL: import.meta.env.VITE_EQ_API_URL,
  EQ_APP_URL: import.meta.env.VITE_EQ_APP_URL,
  LAUNCH_DARKLY_CLIENT_ID: import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_ID,
  SMARTY_EMBEDDED_KEY: import.meta.env.VITE_SMARTY_EMBEDDED_KEY,
  PERSONA_ENV: import.meta.env.VITE_PERSONA_ENV,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  SENTRY_ENV: import.meta.env.VITE_SENTRY_ENV,
};

export const isProduction = () => CONFIG.ENV === "production";
export const isLocal = () => CONFIG.ENV === "local";
